import React from "react";
import { BrowserRouter } from "react-router-dom";
import RouterConfig from './navigation/RouterConfig';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Asegúrate de importar el CSS

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <RouterConfig />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;

